const Bag2 = ({ width = 20, height = 20, color = 'currentColor' }) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 20 20" fill="none">
      <path
        d="M6.25 6.39192V5.58358C6.25 3.70858 7.75833 1.86692 9.63333 1.69192C11.8667 1.47525 13.75 3.23358 13.75 5.42525V6.57525"
        stroke={color}
        strokeWidth="1.15385"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.49937 18.3337H12.4994C15.8494 18.3337 16.4494 16.992 16.6244 15.3587L17.2494 10.3587C17.4744 8.32533 16.891 6.66699 13.3327 6.66699H6.66603C3.1077 6.66699 2.52437 8.32533 2.74937 10.3587L3.37437 15.3587C3.54937 16.992 4.14937 18.3337 7.49937 18.3337Z"
        stroke={color}
        strokeWidth="1.15385"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.9121 9.99967H12.9196"
        stroke={color}
        strokeWidth="1.15385"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.08006 9.99967H7.08754"
        stroke={color}
        strokeWidth="1.15385"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
export default Bag2;
